module.exports = __webpack_public_path__ + "img/1.aff5481e.png";